import React, {useState, useEffect} from "react";
import {axiosClient} from '../api/httpClient';
import {
    Button,
    Card,
    CardPanel,
    CardTitle,
    Col,
    Container,
    Icon,
    Modal,
    ProgressBar,
    Row,
    Select,
    TextInput
} from "react-materialize";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {connect} from "react-redux";
import * as actions from '../actions';
import * as _ from "lodash";
import {Link} from "react-router-dom";
import {errorToast, generateRandomPassword, getUserOptions, getUserShortName, infoToast, isEditor, successToast} from "../api/Util";
import ConfirmationDialog from "./ConfirmationDialog";
import {ADMIN, QA_USER, TEAM_LEAD, YT_HELPER, YT_HELPER_LEAD, SUB_ADMIN} from "../api/Constants";
import PageHeader from "./TopHeader/PageHeader";
import { Input } from "antd";
import CustomDropdown from "./common/CustomDropdown/DropDown";

function populateUsers(props, confirmationOpen, setConfirmationOpen, onConfirmDelete, setOnConfirmDelete, customerType) {
    if (!props.users.users && !props.users.loadingUsers) {
        props.fetchAllUsers();
        return (
            <ProgressBar/>
        );
    }
    if (_.isEmpty(props.users.users)) {
        return (
            <CardPanel style={{padding: "12px", textAlign: "center"}}>
                <span style={{fontSize: "1.1em"}}>No users found</span>
            </CardPanel>
        );
    }

    function onClickDelete(e, user) {
        setOnConfirmDelete((event) => () => deleteUser(event, user));
        setConfirmationOpen(true);
    }

    function onClickDeactivate(e, user) {
        console.log(e, user)
        axiosClient.post(`/api/user/${user.client_id}/toggleUserSubscription`, {
            client_id: user.client_id, is_active_subscription: user.is_active_subscription ? 0 : 1
        }).then(({data}) => {
            successToast(data.status || "Status updated");
            props.fetchAllUsers();
        }).catch(err => {
           errorToast("Something went wrong");
           console.error(err);
        });
    }

    async function deleteUser(e, user) {
        try {
            let response = await axiosClient.delete('/api/user/' + user.client_id);
            successToast(response.data.message);
            props.removeUser(user);
        } catch (err) {
            errorToast(err.data.message || "Unable to delete user");
        }
        setConfirmationOpen(false);
    }

    function filterByUserType(user) {
        switch (customerType) {
            case "is_on_leave":
                return user?.is_on_leave === 1;
            case "on_working":
                return user?.is_on_leave === 0;
            default:
                return true;
        }
    }

    const confirmationDialogId = "userDeleteConfirmationDialog";

    return (
        <Container>
            <ConfirmationDialog
                onNegative={() => setConfirmationOpen(false)}
                onPositive={onConfirmDelete}
                confirmationHeader="Caution"
                confirmationDialogId={confirmationDialogId}
                confirmation={confirmationOpen}
                confirmationText="Are you sure you want to delete user?"
            />
            {
                _.map(
                    _.filter(props.users.users, (user) => {
                        const searchedUserFilter = props?.users?.searchedUser ?
                            user?.fullname?.toLowerCase().includes(props?.users?.searchedUser?.toLowerCase()) :
                            true;

                        const userTypeFilter = filterByUserType(user);
                        return searchedUserFilter && userTypeFilter;
                    }),
                    (user) => {
                    return (
                        <Col s={12} m={6} l={4} key={`user-${user.client_id}`}>
                            {user.client_type !== 'customer'?
                            <Card
                                header={<CardTitle className="user-card-title" image="">
                                    <Link to={`/user/${user.client_id}/profile`}>{getUserShortName(user.fullname)}</Link>
                                </CardTitle>}
                                actions={[
                                    <div className="user-btns-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Button key={`delete-${user.client_id}`} onClick={e => onClickDelete(e, user)}
                                                        className="btn-danger">
                                                    Delete <Icon right>delete_forever</Icon>
                                                </Button>
                                                <Button key={`inactive-${user.client_id}`} onClick={e => onClickDeactivate(e, user)}
                                                className={user.is_active_subscription ? "btn-danger" : "btn-primary"}>
                                            {user.is_active_subscription ? "Deactivate" : "Activate"}<Icon right>check</Icon>
                                        </Button>
                                    </div>
                                ]}>
                                <Container style={{marginTop: "10px"}}>
                                    <Row>
                                        <Col s={12}>
                                            <FontAwesomeIcon
                                                icon="user-tag"/>&nbsp;{(user.client_type || "").toUpperCase()}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col s={12}>
                                            <FontAwesomeIcon icon="users"/>&nbsp;{user.client_type === 'team-lead'
                                            ?"Assigned QA:":'Assigned customers:' }
                                            {user.client_type === 'team-lead'? user.assigned_qa:user.assigned_customers}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col s={12}>
                                            <FontAwesomeIcon icon="at"/>&nbsp;<a target="_blank" rel="noopener noreferrer"
                                            href={`mailto:${user.useremail}`}>{user.useremail}</a>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col s={12}>
                                            <span>
                                                <FontAwesomeIcon icon="at"/>&nbsp;Alternate:
                                                {
                                                    user.secondary_email ? (
                                                        <a target="_blank" rel="noopener noreferrer" href={`mailto:${user.secondary_email}`}>{user.secondary_email || 'NA'}</a>
                                                    ) : ""
                                                }
                                            </span>
                                        </Col>
                                    </Row>
                                </Container>
                            </Card>
                            :''}
                        </Col>
                    );
                })
            }
        </Container>
    );
}

export default connect(mapStateToProps, actions)((props) => {
    let [firstName, setFirstName] = useState("");
    let [lastName, setLastName] = useState("");
    let [email, setEmail] = useState("");
    let [password, setPassword] = useState("");
    let [type, setType] = useState(QA_USER);
    let [teamLead, setTeamLead] = useState("0");
    let [disableTeamLead, setDisableTeamLead] = useState(true);
    let [modalOpen, setModalOpen] = useState(false);
    let [addDisabled, setAddDisabled] = useState(true);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [onConfirmDelete, setOnConfirmDelete] = useState(() => {});
    const [customerType, setCustomerType] = useState('');

    async function addUser(e) {
        setAddDisabled(true);
        try {
            e.preventDefault();
            let response = await axiosClient.post('/api/user',
                {
                    firstname: firstName, lastname: lastName, email, password, customer_type: type,
                    assign_team_lead: disableTeamLead ? null : Number(teamLead), subAdminCheck: 0
                });
            successToast(response.data.message);
            setAddDisabled(false);
            if (response.data && !_.isEmpty(response.data.entity)) {
                props.addUser(response.data.entity);
            }
            setModalOpen(false);
        } catch (err) {
            if (err?.response?.data?.error_message && err?.response?.data?.error_message !== "") {
                errorToast(err.response.data.error_message);
            } else {
                errorToast('Something went wrong: ' + err.message);
            }
            setAddDisabled(false);
        }
    }

    // To Enable the add Button if fields are not empty
    useEffect(() => {
        if (
            firstName !== "" &&
            email !== "" &&
            password !== "" &&
            type !== ""
        ) {
            setAddDisabled(false);
        } else {
            setAddDisabled(true);
        }
        }, [firstName, email, password, type]);

    function setRandomPassword() {
        setPassword(generateRandomPassword);
    }

    function resetFields() {
        setFirstName("");
        setLastName("");
        setEmail("");
        setPassword("");
        setType(QA_USER);
        setDisableTeamLead(false);
        setTeamLead("0");
    }

    const getIconName = () => {
        switch (customerType) {
            case "is_on_leave":
                return "work_off";
            case "on_working":
                return "work";
            default:
                return "group"; // Default icon or no icon
        }
    };

    const handleCustomerTypeChange = (value) => {
        setCustomerType(value);
    };

    function onUserTypeChange(e) {
        setType(e.target.value);
        setTeamLead("0");
        if (isEditor({client_type: e.target.value})) {
            setDisableTeamLead(false);
        } else {
            setDisableTeamLead(true);
        }
    }
    
    const options = [
        { value: "", label: "All Users" },
        { value: "is_on_leave", label: "On Leave" },
        { value: "on_working", label: "Working" }
    ];

    return (
        <Container id="user_cards">
            <PageHeader title="Users" />
            <Row className="users-top-btn">
            <Col className="inputSearchUser" >
                    <Input
                        placeholder="Search by name"
                        allowClear 
                        className="searchedUser"
                        style={{height:"50px" }}
                        value={props.users.searchedUser}
                        onChange={(e) => props.searchUser(e.target.value)}
                    />
                </Col> 
				<Icon className="user-type-Icon">{getIconName()}</Icon>
                <CustomDropdown
                    options={options}
                    placeholder="User Type"
                    className="user-type-dropdown"
                    dropdownValue={customerType}
                    handleOnchange={handleCustomerTypeChange}
                />

                <Col className="addNewUserButton">
                    <Modal
                        actions={[
                            <Button flat modal="close" node="button" className="btn-danger" large>Close</Button>,
                            <Button modal="close" onClick={e => addUser(e)} disabled={addDisabled} node="button"
                                    waves="green" className="btn-primary" large>Add</Button>
                        ]}
                        trigger={(
                            <CardPanel style={{padding: "12px", textAlign: "center", cursor: "pointer"}}
                                       className="color-green standard-btn">
                                <FontAwesomeIcon icon="plus" inverse/>&nbsp;&nbsp;
                                <span className="text-primary" style={{fontSize: "1.1em"}}>Add User</span>
                            </CardPanel>
                        )}
                        header="Add New User"
                        id="addUserModal"
                        open={modalOpen}
                        options={{
                            dismissible: true,
                            endingTop: '10%',
                            opacity: 0.5,
                            preventScrolling: true,
                            onOpenStart: resetFields,
                            onCloseEnd: () => setModalOpen(false)
                        }}
                    >
                        <Container>
                            <Row>
                                <TextInput s={12} m={6} id="txtFirstName" label="First Name" icon="person"
                                           value={firstName} onChange={e => setFirstName(e.target.value)}/>
                                <TextInput s={12} m={6} id="txtLastName" label="Last Name" icon="person"
                                           value={lastName} onChange={e => setLastName(e.target.value)}/>
                            </Row>
                            <Row>
                                <TextInput s={12} m={6} id="txtEmail" label="Email" email validate icon="email"
                                           value={email} onChange={e => setEmail(e.target.value)}/>
                                <TextInput s={12} m={6} icon={<Button flat
                                                                      onClick={e => setRandomPassword()}><Icon>lock</Icon></Button>}
                                           id="txtPassword" label="Password" password
                                           value={password} onChange={e => setPassword(e.target.value)}/>
                            </Row>
                            <Row>
                                <Select s={12} m={6}
                                        icon={<Icon>assignment</Icon>}
                                        id="clientType"
                                        label="User Type"
                                        value={type}
                                        onChange={e => onUserTypeChange(e)}>
                                    <option value={YT_HELPER}>
                                        Youtube Helper
                                    </option>
                                    <option value={QA_USER}>
                                        QA
                                    </option>
                                    <option value={TEAM_LEAD}>
                                        Team Lead
                                    </option>
                                    <option value={YT_HELPER_LEAD}>
                                        Youtube Helper Team Lead
                                    </option>
                                    <option value={ADMIN}>
                                        Admin
                                    </option>
                                    <option value={SUB_ADMIN}>
                                        Sub Admin
                                    </option>
                                </Select>
                                <Select s={12} m={6}
                                        icon={<Icon>supervisor_account</Icon>}
                                        id="assignTeamLead"
                                        label="Team Lead"
                                        value={teamLead}
                                        disabled={disableTeamLead}
                                        onChange={e => setTeamLead(e.target.value)}>
                                    <option value="0">
                                        None
                                    </option>
                                    {getUserOptions(props.users.users, TEAM_LEAD)}
                                </Select>
                            </Row>
                        </Container>
                    </Modal>
                </Col>

                <Col className="reloadAllUsersBtn">
                    <CardPanel 
                               className="red darken-1 standard-btn"
                               onClick={() => {
                                   props.fetchAllUsers();
                                   props.searchUser('');
                                   infoToast("Reloading users")
                               }}>
                        <FontAwesomeIcon icon="sync" inverse/>&nbsp;&nbsp;<span className="text-primary"
                                                                                style={{fontSize: "1.1em"}}>Users</span>
                    </CardPanel>
                </Col>
            </Row>
            <Row className="users-row-cards">
                {populateUsers(props, confirmationOpen, setConfirmationOpen, onConfirmDelete, setOnConfirmDelete, customerType)}
            </Row>
        </Container>
    );
});

function mapStateToProps({users}) {
    return {users};
}
